import { ReactNode } from 'react';

export const RunsTablePopoverItem = (props: {
  title?: string;
  subtitle?: ReactNode;
}) => {
  return (
    <div className="inline-flex w-[480px] items-center justify-start rounded-lg pl-3.5 pr-2.5">
      <div className="inline-flex shrink grow basis-0 flex-col items-start justify-center gap-1">
        {props.title && (
          <div className="inline-flex items-center justify-start gap-1.5 self-stretch">
            <div className="text-sm font-semibold leading-normal">
              {props.title}
            </div>
          </div>
        )}
        {props.subtitle && (
          <div className="inline-flex items-baseline justify-start gap-1.5">
            <div className="text-xs font-normal leading-none text-slate-400">
              {props.subtitle}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
